// kapigen version 0.1.34
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { UserWireFormat3 as KaggleSdkUsersUserWireFormat3 } from "../users";
var defaultCategory = {
    id: 0,
    isInherited: false,
    datasetCount: 0,
    competitionCount: 0,
    scriptCount: 0,
    totalCount: 0
};
export var CategoryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCategory, wireFormat);
        return message;
    }
};
export var CroppedImageRectangleWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CroppedImageUploadWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.cropRectangles) {
            wireFormat.cropRectangles = message.cropRectangles.map(function(i) {
                return CroppedImageRectangleWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultDiskUsageLimits = {
    maxFiles: 0
};
export var DiskUsageLimitsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiskUsageLimits, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.publicLimits) {
            message.publicLimits = DiskUsagePublicLimitsWireFormat3.fromJson(wireFormat.publicLimits);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.privateLimits) {
            message.privateLimits = DiskUsagePrivateLimitsWireFormat3.fromJson(wireFormat.privateLimits);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maxFiles) {
            message.maxFiles = parseInt(wireFormat.maxFiles);
        }
        return message;
    }
};
var defaultDiskUsagePrivateLimits = {
    totalBytes: 0,
    usedBytes: 0,
    totalBytesAllVersions: 0,
    usedBytesAllVersions: 0
};
export var DiskUsagePrivateLimitsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiskUsagePrivateLimits, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalBytes) {
            message.totalBytes = parseInt(wireFormat.totalBytes);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usedBytes) {
            message.usedBytes = parseInt(wireFormat.usedBytes);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalBytesAllVersions) {
            message.totalBytesAllVersions = parseInt(wireFormat.totalBytesAllVersions);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.usedBytesAllVersions) {
            message.usedBytesAllVersions = parseInt(wireFormat.usedBytesAllVersions);
        }
        return message;
    }
};
var defaultDiskUsagePublicLimits = {
    maxBytes: 0,
    isOrganizationLimit: false,
    isAdminLimit: false
};
export var DiskUsagePublicLimitsWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiskUsagePublicLimits, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.maxBytes) {
            message.maxBytes = parseInt(wireFormat.maxBytes);
        }
        return message;
    }
};
var defaultFileDownload = {
    contentType: "",
    fileName: "",
    token: ""
};
export var FileDownloadWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFileDownload, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.contentLength) {
            message.contentLength = parseInt(wireFormat.contentLength);
        }
        return message;
    }
};
var defaultHttpRedirect = {
    url: "",
    permanent: false
};
export var HttpRedirectWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultHttpRedirect, wireFormat);
        return message;
    }
};
var defaultImage = {};
export var ImageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultImage, wireFormat);
        return message;
    }
};
var defaultPageMessage = {};
export var PageMessageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultPageMessage, wireFormat);
        if ((wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.type) != undefined) {
            message.type = PageMessageTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
var defaultVoteButton = {
    totalVotes: 0,
    hasAlreadyVotedUp: false,
    hasAlreadyVotedDown: false,
    canUpvote: false,
    canDownvote: false,
    voters: [],
    showVoters: false,
    alwaysShowVoters: false
};
export var VoteButtonWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultVoteButton, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voters) {
            message.voters = wireFormat.voters.map(function(i) {
                return KaggleSdkUsersUserWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.currentUserInfo) {
            message.currentUserInfo = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.currentUserInfo);
        }
        return message;
    }
};
export var PageMessageType;
(function(PageMessageType) {
    PageMessageType["ERROR"] = "error";
    PageMessageType["INFO"] = "info";
    PageMessageType["WARNING"] = "warning";
    PageMessageType["SUCCESS"] = "success";
    PageMessageType["SITE"] = "site";
})(PageMessageType || (PageMessageType = {}));
export var PageMessageTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "ERROR":
            default:
                return PageMessageType.ERROR;
            case "INFO":
                return PageMessageType.INFO;
            case "WARNING":
                return PageMessageType.WARNING;
            case "SUCCESS":
                return PageMessageType.SUCCESS;
            case "SITE":
                return PageMessageType.SITE;
        }
    }
};
export var VoteType;
(function(VoteType) {
    VoteType["UNSPECIFIED"] = "unspecified";
    VoteType[// Casts an approval/positive vote.
    "UPVOTE"] = "upvote";
    VoteType[// Removes a previous vote.
    "DELETE_VOTE"] = "deleteVote";
})(VoteType || (VoteType = {}));
export var VoteTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case VoteType.UNSPECIFIED:
            case 0:
            default:
                return "VOTE_TYPE_UNSPECIFIED";
            case VoteType.UPVOTE:
            case 1:
                return "UPVOTE";
            case VoteType.DELETE_VOTE:
            case 2:
                return "DELETE_VOTE";
        }
    }
};
